import i18n from './i18n'

export default [
    {
        name: i18n.t('sidebar.search'),
        icon: 'ti-user',
        collapsed: false,
        path: '/list'
    },
    {
        name: i18n.t('sidebar.add-user'),
        icon: 'ti-user',
        collapsed: false,
        path: '/add'
    },
    {
        name: i18n.t('sidebar.cash-deposit'),
        icon: 'ti-user',
        collapsed: false,
        path: '/cash-deposit'
    },
]